import { gql } from "@apollo/client";
import { EMAIL_AUTOMATION_FIELDS, EMAIL_AUTOMATION_SEND_FIELDS } from "./fragments";

export const GET_TRAVEL_EMAIL_AUTOMATION_CATALOG = gql`
  query GetTravelEmailAutomationCatalog {
    travelEmailAutomationCatalog {
      id
      type
      events {
        id
        key
        group
        subtype
      }
      properties {
        id
        key
        group
        dataType
        values
        operators
        canTrigger
        subtype
      }
    }
  }
`;

export const GET_TRAVEL_EMAIL_AUTOMATIONS = gql`
  query GetTravelEmailAutomations(
    $searchTerm: String
    $includeInactive: Boolean! = false
    $pageSize: Int! = 50
    $pageNumber: Int! = 0
  ) {
    travelEmailAutomations(
      searchTerm: $searchTerm
      includeInactive: $includeInactive
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      count
      pageSize
      pageNumber
      items {
        ${EMAIL_AUTOMATION_FIELDS}
      }
    }
  }
`;

export const GET_TRAVEL_EMAIL_AUTOMATION = gql`
  query GetTravelEmailAutomation($id: String!) {
    travelEmailAutomation(id: $id) {
      ${EMAIL_AUTOMATION_FIELDS}
    }
  }
`;

export const GET_TRAVEL_EMAIL_AUTOMATION_SENDS = gql`
  query GetTravelEmailAutomationSends(
    $automationId: String!
    $status: NotificationAutomationSendStatus
    $pageSize: Int! = 50
    $pageNumber: Int! = 0
  ) {
    travelEmailAutomationSends(
      automationId: $automationId
      status: $status
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      count
      pageSize
      pageNumber
      items {
        ${EMAIL_AUTOMATION_SEND_FIELDS}
      }
    }
  }
`;

export const GET_TRAVEL_AIRPORTS = gql`
  query GetTravelAirports($searchTerm: String, $pageSize: Int! = 20, $pageNumber: Int! = 0) {
    travelAirports(searchTerm: $searchTerm, pageSize: $pageSize, pageNumber: $pageNumber) {
      count
      items {
        id
        iataCode
        name
        city
        countryCode
        timezone
      }
    }
  }
`;
